/** @format */

import { useTheme } from '@mui/material/styles';
import { Toaster as HotToaster } from 'react-hot-toast';
// import { useEffect, useState } from "react";

const Toaster = () => {
  const theme = useTheme();

  // const [notification, setNotification] = useState({ title: "", body: "" });

  // useEffect(() => {
  //   if (notification?.title) {
  //     toast.success(`${notification?.title}: ${notification?.body}`);
  //   }
  // }, [notification]);

  // useEffect(() => {
  //   const unsubscribe = onMessageListener().then((payload) => {
  //     setNotification({
  //       title: payload?.notification?.title,
  //       body: payload?.notification?.body,
  //     });
  //     toast.success(
  //       `${payload?.notification?.title}: ${payload?.notification?.body}`
  //     );
  //   });

  //   return unsubscribe.catch((err) => console.log("failed: ", err));
  // });
  // console.log("onMessageListener");
  // onMessageListener()
  //   .then((payload) => {
  //     console.log("onMessageListener");
  //     setNotification({
  //       title: payload?.notification?.title,
  //       body: payload?.notification?.body,
  //     });
  //   })
  //   .catch((err) => console.log("failed: ", err));

  return (
    <HotToaster
      containerClassName="host-toaster-parent"
      position="top-right"
      toastOptions={{
        duration: 1800,
        style: {
          // backdropFilter: 'blur(6px)',
          // background: alpha(theme.palette.neutral[900], 0.8),
          // color: theme.palette.common.white,
          boxShadow: theme.shadows[16],
          zIndex: 99999,
          transition: 'transform 0.3s ease, opacity 0.3s ease'
        }
      }}
    />
  );
};

export default Toaster;
